export const AUTOCOMPLETE_POSSIBLE_VARIABLES = [
  { value: 'userFullName' },
  { value: 'newsTipPoints' },
  { value: 'newsTipTitle' },
  { value: 'daysUntilExpiration' },
  { value: 'newspaperName' }
]
